import {
  DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP,
  DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP,
  DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP,
  DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP,
  SET_AGE_OPTIONS_FOR_DIVISONS,
  GET_VIRTUAL_EVENT_SCORING_METHODS,
  GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS,
  DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS,
  GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT,
  SET_AGE_VERIFICATION_EVENT_FOR_EVENT,
  GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT
} from './constants';

const newBowlEventModel = {
  editing: true,
  name: '[New Event]'
};

const newVirtualEventModel = {
  editing: true,
  name: '[Create Virtual Event]'
};

const initialState = {
  bowlEvents: [],
  virtualEvents: [],
  ageOptions: [],
  linkableEvents: [],
  scoringMethods: [],
  ownedByOptions: [],
  showScoringMethods: false,
  showOwnedBy: false,
  showAgeOptions: false,
  handicapAppliedOptions: [],
  availableLocationOptions: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP:
      state.virtualEvents.forEach(entry => {
        entry.editing = entry.id === payload;
      });
      return {
        ...state,
        virtualEvents: [...state.virtualEvents.filter(entry => entry.id)], // return only items with information (not empty ones)
        linkableEvents: state.bowlEvents.map(event => ({
          value: event.id,
          label: event.name
        }))
      };
    case CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP:
      state.virtualEvents.forEach(entry => {
        entry.editing = false;
      });
      return {
        ...state,
        virtualEvents: [...state.virtualEvents.filter(entry => entry.id)] // return only items with information (not empty ones)
      };
    case DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP:
      return payload
        ? {
          ...state,
          virtualEvents: [...payload]
        }
        : state;
    case DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP: {
      return {
        ...state,
        virtualEvents: [
          {...newVirtualEventModel},
          ...state.virtualEvents
        ],
        linkableEvents: state.bowlEvents.map(event => ({
          value: event.id,
          label: event.name
        }))
      };
    }
    case DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP: {
      return {
        ...state,
        bowlEvents: [
          {...newBowlEventModel},
          ...state.bowlEvents
        ]
      };
    }
    case DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP: {
      state.bowlEvents.forEach(entry => {
        entry.editing = entry.id === payload;
      });
      return {
        ...state,
        bowlEvents: [...state.bowlEvents.filter(entry => entry.id)] // return only items with information (not empty ones)
      };
    }
    case CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP: {
      state.bowlEvents.forEach(entry => {
        entry.editing = false;
      });
      return {
        ...state,
        bowlEvents: [...state.bowlEvents.filter(entry => entry.id)] // return only items with information (not empty ones)
      };
    }
    case DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP:
      return {
        ...state,
        bowlEvents: [...payload]
      };
    case SET_AGE_OPTIONS_FOR_DIVISONS:
      return {
        ...state,
        ageOptions: payload || initialState.ageOptions
      };
    case DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS:
      return {
        ...state,
        showAgeOptions: payload || initialState.showAgeOptions
      };
    case GET_VIRTUAL_EVENT_SCORING_METHODS:
      return {
        ...state,
        scoringMethods: payload || initialState.scoringMethods
      };
    case GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS:
      return {
        ...state,
        ownedByOptions: payload || initialState.ownedByOptions
      };
    case DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS:
      return {
        ...state,
        showScoringMethods: payload || initialState.showScoringMethods
      };
    case DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS:
    return {
      ...state,
      showOwnedBy: payload || initialState.showOwnedBy
    };
    case GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT:
      return {
        ...state,
        handicapAppliedOptions: payload || initialState.handicapAppliedOptions
      };
    case SET_AGE_VERIFICATION_EVENT_FOR_EVENT: {
      return {
        ...state,
        ageVerificationDate: payload || initialState.ageVerificationDate
      };
    }
    case GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT:
      return {
        ...state,
        availableLocationOptions: payload || initialState.availableLocationOptions
      };
    default:
        return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/events/reducer.js